import { mapEnumToOptions } from '@abp/ng.core';

export enum Offset {
  Day = 0,
  Hour = 1,
}

export const offsetOptions = mapEnumToOptions(Offset);
